<template lang="pug">
.new-article-default
  shForm(title="Nuevo Artículo Predeterminado")
</template>

<script>
import shForm from '@/components/pages/articleDefault/Form'

export default {
  name: 'NewArticleDefault',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-article-default
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/articleDefault/New.vue